// Este ficheiro agora usa o OneSignal para fazer o telemóvel vibrar
export const dispararPushNoBolso = async (userIdDestino, titulo, mensagem) => {
  
  // Aqui metes a tua REST API KEY que foste buscar ao site do OneSignal
  const REST_API_KEY = "os_v2_app_5exjkm2gtbclhcqjkm7voiy6kmyj7qzjfeeu2tnmjrsipc2owvfv5h3y6ecoeori6ugfjyoijiwkdstug7bvvaftbqiff5prezpdepq"; 
  const APP_ID = "e92e9533-4698-44b3-8a09-533f57231e53";

  try {
    const resposta = await fetch("https://onesignal.com/api/v1/notifications", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": `Basic ${REST_API_KEY}`
      },
      body: JSON.stringify({
        app_id: APP_ID,
        // O "external_id" é o UID do utilizador que gravámos lá no App.jsx
        include_aliases: { "external_id": [userIdDestino] },
        target_channel: "push",
        contents: { "en": mensagem, "pt": mensagem },
        headings: { "en": titulo, "pt": titulo }
      })
    });

    const resultado = await resposta.json();
    console.log("Resposta do OneSignal:", resultado);
  } catch (error) {
    console.error("Erro ao enviar para o bolso:", error);
  }
};
